module.exports = __webpack_public_path__ + "assets/playernoop.de1d428b.svg";